var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.5 26.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-F1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.26,3.28a9,9,0,0,0-7-3.28,9,9,0,0,0-7,3.28C3.42,6.62,4.18,8.5,3.86,13.3a9.74,9.74,0,0,1-.48,2.49H3.27c-.06.21-.12.42-.2.63a10.26,10.26,0,0,1-1.31,2.3C.79,20-.11,20.75,0,21.61c-.11.77.57,1.24,2.92,1.22h.69c1.84.1,4,0,5.67-.06l4,0,4,0c1.64.07,3.83.16,5.67.06h.68c2.35,0,3-.45,2.93-1.22.12-.86-.78-1.64-1.75-2.88a10.72,10.72,0,0,1-1.32-2.3c-.07-.21-.14-.42-.2-.63h-.1a9.74,9.74,0,0,1-.48-2.49C22.32,8.5,23.08,6.62,20.26,3.28Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.94,24.46c-1,0-3.5-.26-4.2.14.23.51-.07.3.52.72.16.12.44.32.63.44a4.72,4.72,0,0,0,5-.3c1.93-1.42-.43-1-1.93-1Z",
    transform: "translate(0 0)",
    fill: "#bac7d6",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/F1.b0165c03574164a1f7bc9b2b1576cfb3.svg";
export { ForwardRef as ReactComponent };